import React, { memo, FC, useMemo } from 'react';
import classNames from 'classnames';
import {
  Button,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Caption1Strong,
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';
import { ChevronDown20Regular } from '@fluentui/react-icons';

export const useStyles = makeStyles({
  dropdown: {
    ...shorthands.flex(0, 0, 'auto'),
    alignSelf: 'start',
  },
  dropdownTriggerButton: {
    ...shorthands.padding('0px', '0px', '3px', '0px'),
    ':active': { backgroundColor: tokens.colorNeutralStroke1Hover },
    ':hover': { backgroundColor: tokens.colorNeutralStroke1Hover },
  },
});

export interface IMetricPickerProps {
  metrics: Array<{
    key: string,
    displayName: string,
  }>;
  onMetricSelect: (key: string) => void;
  selectedMetricKey: string;
}

export const MetricPicker: FC<IMetricPickerProps>
  = memo(({ metrics, onMetricSelect, selectedMetricKey }: IMetricPickerProps) => {
    const classes = useStyles();

    const dropdownItems = useMemo(() => metrics.map((metric) => {
      const handleDropdownSelect = () => {
        onMetricSelect(metric.key);
      };
      return (
        <MenuItem
          key={metric.key}
          onClick={handleDropdownSelect}
          className={classNames('ba-metric-picker-menu-button-item', `metric-${metric.key}`)}
        >
          {metric.displayName}
        </MenuItem>
      );
    }), [metrics, onMetricSelect]);

    return (
      <div className={classNames('ba-metric-picker-menu-button', classes.dropdown)}>
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <Button
              className={classNames('ba-metric-picker-menu-button-trigger', classes.dropdownTriggerButton)}
              appearance="subtle"
              icon={<ChevronDown20Regular />}
              iconPosition="after"
              size="medium"
            >
              <Caption1Strong>{metrics?.find(m => m?.key === selectedMetricKey)?.displayName}</Caption1Strong>
            </Button>
          </MenuTrigger>
          <MenuPopover>
            <MenuList className="ba-metric-picker-menu-button-list">
              {dropdownItems}
            </MenuList>
          </MenuPopover>
        </Menu>
      </div>
    );
  });
